import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

let apiToken = JSON.parse(localStorage.getItem("authUser"))
const headers = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
  Authorization: apiToken,
  Accept: "application/json",
  "Cache-Control": "no-cache",
}

export const addEmployeeAPI = async employeeData => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(
      `${apiBaseUrl}/create-employee`,
      employeeData,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error adding employee:", error)
    throw error
  }
}

//  to get employee

export const getEmployeeAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/myemployees`, {
    headers,
  })
}

// to delete employee

export const deleteEmployeeAPI = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.post(`${apiBaseUrl}/delete-employee`, payload.payload, {
    headers,
  })
}

export const editEmployeeAPI = async employeeData => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  try {
    const response = await axios.post(
      `${apiBaseUrl}/update-employee`,
      employeeData,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error adding employee:", error)
    return error
  }
}

// verify employee otp

export const verifyEmpOTPAPI = async payload => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "*",
  }
  return await axios.post(`${apiBaseUrl}/verify-employee`, payload.payload, {
    headers,
  })
}

// GET EMPLOYEE PROFILE

export const getEmployeeProfileApi = async payload => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-mypofile-employee`, {
    headers,
  })
}

export const viewEmployeeAPI = async customerData => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  //console.log("SAGA API" + customerData)

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  const data = {
    id: customerData,
  }

  try {
    const response = await axios.post(`${apiBaseUrl}/view-employee`, data, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error adding Customer:", error)
    throw error
  }
}

// MY EMPLOYEE API


export const MYEmployeeAPI = async payload => {

  try {

    const data = {
      id: payload.payload
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(
      `${apiBaseUrl}/myUsers`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error adding employee:", error)
    throw error
  }
}



export const transferEmpAssetsAPI = async (payload) => {

  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(
      `${apiBaseUrl}/transfer-employee-assests`,
      payload.payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error adding employee:", error)
    throw error
  }
}